<template>
    <div class="accountrecorder">
        <topNav :title="title"></topNav>
        <section class="list list_parkings">
            <ul v-show="parkingList && parkingList.length">
              <li class="parking_item" v-for="(item, index) in parkingList" :key="index" @click="getParkingPayRecord(item)">
                  <div class="parkingname">{{item.parkingname}}</div>
              </li>
            </ul>
            <div class="empty_container" v-show="!parkingList.length && !loadingParking">
                <div class="cont">
                  <div class="icon icon_noinvoice"></div>
                  <p class="tips">暂无停车场</p>
                </div>
                <div class="empty_tip_module">
                  <p>可以往【扫码支付开票】查询开票</p>
                  <p>如果还是未查询到，可能是以下原因：</p>
                  <p>1.您的订单不在查询时间区间内</p>
                </div>
            </div>
          
            <div class="loadmore" v-if="loadingParking"><van-loading type="spinner" /></div>
        </section>
    </div>
</template>
<script>
import topNav from "../../topnav/topnav"
import {DETAIL as API} from "@/assets/api"

export default {
  name: 'choosePark',
  components:{
     topNav,
  },
  data() {
    return {
      title:"选择停车场",
      
      carNum: '',
      parkingno: '',
      loadingParking: false,
      parkingList: [],
      
    }
  },
  computed: {
    
  },
  methods:{
    getParks(carNum){
      var req = { carNum: carNum }
      this.loadingParking = true
      this.$http({
          method: 'post',
          url: API.GET_PARKS,
          data: req,
          success: function(res){
            if(res.code == 500){
                this.Toast(res.msg)
                this.loadingParking = false
                return
            }
            if(res.data && res.data.length > 0){
              this.parkingList = res.data.filter(i=>i.parkingno)
            }
            this.loadingParking = false
          }.bind(this),
          error: function(error){
            this.loadingParking = false
          }
      })
    },
    getParkingPayRecord(item){
      var query = {
        carNum: this.carNum,
        commid: item.commid,
        parkingno: item.parkingno,
        parkingname: item.parkingname,
        appid: item.appid
      }
      this.$router.push({name: 'invoiceParkingPayRecord', query: query})
    },
  },
  created(){
    this.carNum = this.$route.query.carNum
    this.getParks(this.carNum)
  },
}
</script>
<style lang="less" scoped>
.accountrecorder{
  min-height: 100vh;
  border-bottom:1px solid #fff; 
  background-color: #fff;
  box-sizing: border-box;
}

.parkingname{
  font-size: 17px;
  line-height: 32px;
  text-align: center;
}


.list_parkings{
  .parking_item{
    position: relative;
    height: 210px/2;
    width: 705px/2;
    margin: 10px auto;
    background: url('../../../../static/images/bg_parkingname.png') center no-repeat;
    background-size: 100%;
    .parkingname{
      width: 100%;
      font-size: 20px;
      letter-spacing: 2px;
      color: #ffffff;
      font-family: AlibabaPuHuiTi-Regular;
      line-height: 90px;
    }
  }
  .emptyTip{
    font-size: 16px;
    text-align: center;
    line-height: 60px;
  }
}

.empty_container{
  margin-top: 80px;
  .cont{
    margin-bottom: 30px;
    .icon_noinvoice{
      width: 161px;
      height: 127px;
      margin: 0 auto;
      background: url('../../../../static/images/icon_noinvoice.png') center no-repeat;
      background-size: 100% auto;
    }
    .tips{
      text-align: center;
      color: #333;
    }
  }
  .empty_tip_module{
    line-height: 32px;
    h5{
      font-weight: bold;
      color: #666;
      font-size: 14px;
    }
    p{
      font-size: 12px;
      color: #999;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/my/electronicInvoice/choosePark.vue